import L from 'leaflet'
// import 'proj4leaflet'
import * as esri from 'esri-leaflet'

export default {
  install (Vue, opts) {
    // console.log('Installing GMP_DataViz leafletMapPlugin...')
    const optionsDefaults = {
      //   OPENSTREET MAP
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      //   GOOGLE MAPS
      //   Note the difference in the "lyrs" parameter in the URL:
      //   Hybrid: s,h;
      //   Satellite: s;
      //   Streets: m;
      //   Terrain: p;
      url2: 'http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
      mapCenter: [49.314013, 16.349112],
      maxZoom: 18
    }
    const options = { ...optionsDefaults, ...opts }

    Vue.mixin({
      methods: {
        changeMapBackground: function (center) {
          if (this.$route.hash) {
            let mapProjection = ''
            let mapType = ''

            if (this.$hashPlugin.stringToArray(this.$route.hash.substr(1).split('|')[1], 'settings').find(it => it.settingCode === 'map_projection')) {
              mapProjection = this.$hashPlugin.stringToArray(this.$route.hash.substr(1).split('|')[1], 'settings').find(it => it.settingCode === 'map_projection').settingValue
            }
            if (mapProjection === '4326') {
              this.robinsonLayer = L.tileLayer('https://api.maptiler.com/maps/basic-4326/{z}/{x}/{y}.png?key=vrZCjsYuN16gYZIhByaE')
              this.map.addLayer(this.robinsonLayer)
              this.$store.commit('UPDATE_ZOOM_RANGE', [0, 18])
            } else {
              if (this.$hashPlugin.stringToArray(this.$route.hash.substr(1).split('|')[1], 'settings').find(it => it.settingCode === 'map_type')) {
                mapType = this.$hashPlugin.stringToArray(this.$route.hash.substr(1).split('|')[1], 'settings').find(it => it.settingCode === 'map_type').settingValue
              } else {
                mapType = 'Topographic'
              }
              this.esriLayer = esri.basemapLayer(mapType)
              this.map.addLayer(this.esriLayer)

              // add labels layer
              if (mapType === 'Imagery') {
                this.esriLayerImageryLabels = esri.basemapLayer('ImageryLabels')
                this.map.addLayer(this.esriLayerImageryLabels)
                this.$store.commit('UPDATE_ZOOM_RANGE', [0, 17])
              } else {
                if (this.esriLayerImageryLabels) {
                  this.map.removeLayer(this.esriLayerImageryLabels)
                }
                this.$store.commit('UPDATE_ZOOM_RANGE', [0, 19])
              }
            }
          } else {
            this.esriLayer = esri.basemapLayer('Topographic')
            this.map.addLayer(this.esriLayer)
          }

          if (center) {
            this.map.setView(center)
          }
        }
      }
    })

    Vue.prototype.$gmpMap = {
      // create leaflet map in container
      createMap: function (container, zoom, zoomListener, epsg, optionsCustom) {
        // init mapy
        let optionsDefault = {
          center: options.mapCenter,
          zoom: zoom, // this.zoom,
          maxZoom: options.maxZoom,
          zoomControl: false,
          preferCanvas: true,
          renderer: L.svg(),
          setView: true,
          crs: L.CRS['EPSG' + epsg]
        }

        let opts = { ...optionsDefault, ...optionsCustom }
        const map = L.map(container, opts)

        // pridani mapove vrstvy s podkladem google maps. Mapove podklady pridavame v jednotlivych vizualizacich, arcgis pres esri
        // const esriLayer = esri.basemapLayer('Topographic')
        // map.addLayer(esriLayer)

        // const robinsonMapLayer = L.tileLayer('https://api.maptiler.com/maps/basic-4326/{z}/{x}/{y}.png?key=8FcpLijWrGuEIGazdxZw')
        // map.addLayer(robinsonMapLayer)

        // L.tileLayer(options.url2, {
        //   maxZoom: options.maxZoom,
        //   attribution: '<a href="https://www.google.com/maps">Google</a>',
        //   subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
        // }).addTo(map)

        // pridani eventu zoom
        map.addEventListener('zoom', function () {
          zoomListener(map.getZoom())
        })
        return map
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/leafletMapPlugin.js